<script setup lang="ts">
    import {computed, ref} from 'vue';
    import useCpBem from '~/composables/useCpBem';
    import CpIconStandard from '~/components/cp/CpIcon/CpIconStandard/CpIconStandard.vue';
    import {toCssVariable as toCss, useColors} from '~/composables/useCpType';

    const toCssVariable = toCss;
    const props = withDefaults(defineProps<{
        type?: 'primary'|'secondary'|'primary-dark'
        icon?: 'goToTop'|'wishListNo'|'wishListYes'|'wishListActions'|'share'|'edit'
        af?: boolean
    }>(), {
        type: 'primary',
        icon: 'goToTop',
        af: false,
    });

    const icon = computed(() => {
        switch (props.icon) {
            case 'goToTop':
                return 'expand_less';
            case 'wishListNo':
                return 'favorite_border';
            case 'wishListYes':
                return 'favorite';
            case 'wishListActions':
                return 'heart_plus';
            default:
                return props.icon;
        }
    });
    const colors = computed(() => {
        if (props.type === 'primary-dark') {
             return useColors('primary');
        } else {
            return useColors(props.type, {hollow: true});
        }
    });
    const properties = computed(() => {
        const hollow = props.type === 'primary-dark';
        return {
            active: active.value && !hollow && !props.af,
            border: colors.value.border! && !active.value,
            borderActive: colors.value.border! && active.value,
            hollow: hollow && !active.value,
            activeHollow: active.value && hollow,
            resize: props.af && props.icon === 'goToTop',
            afColor: props.af,
            afColorActive: props.af && active.value,
        };
    });
    const activeIconColor = computed(() => {
        if (props.type === 'primary') {
            return 'primary-dark';
        } else if (props.type === 'secondary') {
            return 'secondary';
        }
        return 'white';
    });

    const active = ref(false);
    const {bm, e} = useCpBem('cp-button-round');
</script>

<template>
    <div
        :class="bm(properties)"
        @mousedown="active = true"
        @mouseup="active = false"
        @touchstart.passive="active = true"
        @touchend.passive="active = false"
    >
        <CpIconStandard
            :icon="icon"
            :type="active ? activeIconColor : colors.color"
            kind="standard"
        />
    </div>
</template>

<style lang="scss" scoped>
    .cp-button-round {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: v-bind("toCssVariable(colors.background)");
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        &--active{
            background-color: var(--color-primary-extra-light);
        }
        &--border{
            border: 1px solid var(--color-primary);
        }
        &--border-active{
            border: 1px solid var(--color-primary-dark);
        }
        &--hollow{
            background: v-bind("toCssVariable(colors.background)");
        }
        &--active-hollow {
            background-color: var(--color-primary-dark);
        }
        &--resize {
            width: 48px;
            height: 48px;
        }
        &--af-color {
            background-color: var(--color-neutral);
        }
        &--af-color-active {
            background-color: var(--color-neutral-dark);
        }
        &__custom-icon {
          scale: 0.48;
          fill: v-bind("toCssVariable(props.type)");
          margin-top: 2px;
        }
    }
</style>
